const getFixedTimeOptions = () => {
  const pad = (num) => num.toString().padStart(2, '0');
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minutes = 0; minutes < 60; minutes += 15) {
      const value = `${pad(hour)}:${pad(minutes)}`;
      // Convert to 12-hour format for the label
      let labelHour = hour % 12;
      if (labelHour === 0) labelHour = 12;
      const period = hour < 12 ? 'am' : 'pm';
      const label = `${labelHour}:${pad(minutes)}${period}`;
      times.push({ label, value });
    }
  }
  return times;
};

export default getFixedTimeOptions;
